import store from "@/store/index.js";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { COLLECTION_LEADS_CAPTURADOS } from "./collectionsNames.js";
import { db } from "./firebase.js";
import { getUserFranqueadoByTotemId } from "./userFranqueado.js";

export const CapiturarLeads = async (telefone) => {
  const totemUID = store.getters["totem/getTotem"].id;
  const compra = store.getters["compra/getCompra"];
  const compraUID = compra.id;
  const qtdeFoto = Number(compra.qtde_foto) || 0;
  const valorCompra = Number(compra.valor) || 0;

  const discountCollection = collection(db, COLLECTION_LEADS_CAPTURADOS);

  const userFranqueadosList = await getUserFranqueadoByTotemId();
  if (!userFranqueadosList.error) {
    const userFranqueado = userFranqueadosList.franqueados[0] || null;
    if (userFranqueado) {
      store.commit("totem/setTotemFranqueadoId", userFranqueado.userID);
    }
  }

  const franqueadoId = store.getters["totem/getTotem"].franqueadoId || null;
  const now = Timestamp.now();

  // Verifica se já existe um lead com esse telefone para esse franqueado
  const q = query(
    discountCollection,
    where("telefone", "==", telefone),
    where("franqueadoId", "==", franqueadoId)
  );
  const snapshot = await getDocs(q);

  if (!snapshot.empty) {
    // Lead já existe: incrementa fotos e atualiza valor da última compra
    const existingDoc = snapshot.docs[0];
    const existingData = existingDoc.data();
    await updateDoc(doc(db, COLLECTION_LEADS_CAPTURADOS, existingDoc.id), {
      totemUID: totemUID,
      compraUID: compraUID,
      qtdeFotosCompradas: (existingData.qtdeFotosCompradas || 0) + qtdeFoto,
      valorUltimaCompra: valorCompra,
      updated_at: now,
    });
  } else {
    // Novo lead: cria com todas as informações
    await addDoc(discountCollection, {
      totemUID: totemUID,
      compraUID: compraUID,
      telefone: telefone,
      franqueadoId: franqueadoId,
      qtdeFotosCompradas: qtdeFoto,
      valorUltimaCompra: valorCompra,
      timestamp: now,
      created_at: now,
      updated_at: now,
    });
  }
};
